import React, { useState, useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faLock,
  faUser,
  faShieldAlt,
  faRocket,
  faBolt,
  faHeadset,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useHistory } from "react-router-dom";
import cogoToast from "cogo-toast";
import { BASE_URL_APISERVICES, BASE_URL_API } from "../../utils/Constants";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { GlobalContext } from "../../Context/GlobalState";
import "./AdminLogin2.css";
import CompanyLogo from "../../../assets/images/Bumppy_Payment_logo.svg";
import { uniqueID2 } from "../../utils/utilFuctions";

const AdminLogin2 = () => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [data, setData] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showOtpField, setShowOtpField] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const { setUserInfo, setTransactionLoaderState, user } =
    useContext(GlobalContext);

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
    setUsernameError("");
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError("");
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSignIn = () => {
    setUsernameError("");
    setPasswordError("");
    setOtpError("");

    if (username.trim() === "") {
      setUsernameError("Username is required.");
      return;
    }

    if (password.length < 8) {
      setPasswordError("Password must be at least 8 characters.");
      return;
    }
    sendOtpToServer();
  };

  const sendOtpToServer = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + btoa("NoMoreOwnerName@bumppy.com:HJpdmF0ZSBzdGF0aWMgZmluYWwgU3RyaW5n")
   
      )

      var raw = JSON.stringify({
        mobile: username,
        password: password,
        step: "1",
        otp: "",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        // `${BASE_URL_APISERVICES}/api/Payment/admin/dashboardLogin`,
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.ADMIN_SEND_OTP}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setShowOtpField(true);
        cogoToast.success(data.msg);
      } else {
        cogoToast.error(data.msg);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };
  //session_mgt
  const registerSession = async(userPkid, sid) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");


     

      const raw = JSON.stringify({
        userid: userPkid,
        sessionid: sid,
        device: "WEB_ADMIN"
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      const res = await fetch(`${BASE_URL_API}/api/Apitranxt/admin/add_session`,
        requestOptions
      );

      const data = await res.json()
      console.log('add session', data)

      console.log("Session added successfully");
    } catch (error) {
      console.log("Session add error:", error);
    }
  };

  const handleOtpChange = (event) => {
    setOtp(event.target.value);
    setOtpError("");
  };

  // const validateOtpOnServer = async () => {
  //   setOtpError("");
  //   if (otp.trim() === "") {
  //     setOtpError("OTP is required.");
  //     return;
  //   }

  //   try {
  //     setTransactionLoaderState(true);
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");
  //     myHeaders.append(
  //       "Authorization",
  //       "Basic " +
  //         Buffer.from(username + ":" + password).toString(
  //           "base64"
  //         )
  //     );

  //     var raw = JSON.stringify({
  //       mobile: username,
  //       password: password,
  //       step: "2",
  //       otp: otp,
  //     });

  //     var requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };

  //     const res = await fetch(
  //       `${BASE_URL_APISERVICES}${API_ENDPOINTS.ADMIN_VERIFY_OTP}`,
  //       requestOptions
  //     );

  //     const data = await res.json();
  //     if (data.status == "0") {
  //       cogoToast.success(data.msg);
  //       //
  //       const sid = uniqueID2();

  //       localStorage.setItem("sessionid", sid);

  //       const userPkid = data.data.pkid;
  //       console.log("Passing UserID to registerSession:", userPkid);
  //       await registerSession(userPkid, sid);
  //       setUserInfo(data.data);
  //       //
  //       history.push("/admin/dashboard");
  //     } else {
  //       cogoToast.error(data.msg);
  //     }
  //     setTransactionLoaderState(false);
  //   } catch (error) {
  //     setTransactionLoaderState(false);
  //     console.log("error", error);
  //   }
  // };


  const validateOtpOnServer = async () => {
   
    setOtpError("");

    if (otp.trim() === "") {
      setOtpError("OTP is required.");
      return;
    }

    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + btoa("NoMoreOwnerName@bumppy.com:HJpdmF0ZSBzdGF0aWMgZmluYWwgU3RyaW5n")
   
      )
     

      var raw = JSON.stringify({
        mobile: username,
        password: password,
        step: "2",
        otp: otp,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}/api/Payment/admin/dashboardLogin`,
        requestOptions
      );

      const data = await res.json();

      console.log("Full Login Response:", data);

      if (data.status == "0") {
        cogoToast.success(data.msg);
        const sid = uniqueID2()
       
        sessionStorage.setItem("admin_sessionid", sid);

        const userPkid = data.data.pkid;
        console.log("Passing UserID to registerSession:", userPkid);
        await registerSession(userPkid, sid);
        setUserInfo(data.data);
        history.push("/admin/dashboard");
      } else {
        cogoToast.error(data.msg);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };

  return (
    <div id="secure-ui" className="admin-login-container">
      <div className="login-wrapper">
        <div className="left-panel">
          <div className="brand-content">
            <div className="logo-container">
              <div>
                <img
                  src={CompanyLogo}
                  style={{ height: "5rem", width: "auto", color: "#EC5665" }}
                  className="mx-1"
                />
                <p className="brand-subtitle">Admin Portal</p>
              </div>
            </div>

            <div className="tagline-section">
              <h2 className="tagline">
                India's Best Online Money Transfer Platform
              </h2>
              <p className="description">
                Secure, fast, and reliable payment solutions for your business
                needs.
              </p>
            </div>

            <div className="animated-stats">
              <div className="stat-item">
                <div className="stat-value">10,000+</div>
                <div className="stat-desc">Active Users</div>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <div className="stat-value">₹50Cr+</div>
                <div className="stat-desc">Processed Daily</div>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <div className="stat-value">99.9%</div>
                <div className="stat-desc">Uptime</div>
              </div>
            </div>

            <div className="features">
              <div className="feature-item">
                <div className="feature-icon-wrapper">
                  <FontAwesomeIcon
                    icon={faShieldAlt}
                    className="feature-icon"
                  />
                </div>
                <div className="feature-content">
                  <h4>Bank-Grade Security</h4>
                  <p>256-bit SSL encryption & PCI DSS compliant</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon-wrapper">
                  <FontAwesomeIcon icon={faBolt} className="feature-icon" />
                </div>
                <div className="feature-content">
                  <h4>Instant Processing</h4>
                  <p>Real-time transaction processing in seconds</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon-wrapper">
                  <FontAwesomeIcon icon={faHeadset} className="feature-icon" />
                </div>
                <div className="feature-content">
                  <h4>24/7 Support</h4>
                  <p>Round-the-clock customer assistance</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="right-panel">
          <div className="form-container glass-effect">
            <div className="form-header">
              <h2 className="form-title">
                {showOtpField ? "Verify OTP" : "Welcome Back"}
              </h2>
              <p className="form-subtitle">
                {showOtpField
                  ? "Enter the OTP sent to your mobile"
                  : "Sign in to access your dashboard"}
              </p>
            </div>

            <form className="login-form">
              {!showOtpField ? (
                <>
                  <div className="input-group">
                    <label className="input-label">Username</label>
                    <div className="input-wrapper">
                      <FontAwesomeIcon icon={faUser} className="input-icon" />
                      <input
                        type="text"
                        className={`form-input ${usernameError ? "error" : ""}`}
                        placeholder="Enter your username"
                        value={username}
                        onChange={handleUsernameChange}
                        style={{ width: "100%", minWidth: "0" }}
                      />
                    </div>
                    {usernameError && (
                      <span className="error-message">{usernameError}</span>
                    )}
                  </div>

                  <div className="input-group">
                    <label className="input-label">Password</label>
                    <div className="input-wrapper">
                      <FontAwesomeIcon icon={faLock} className="input-icon" />
                      <input
                        type={showPassword ? "text" : "password"}
                        className={`form-input ${passwordError ? "error" : ""}`}
                        placeholder="Enter your password"
                        value={password}
                        onChange={handlePasswordChange}
                        style={{ width: "100%", minWidth: "0" }}
                      />
                      <button
                        type="button"
                        className="toggle-password"
                        onClick={handleTogglePassword}
                      >
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                        />
                      </button>
                    </div>
                    {passwordError && (
                      <span className="error-message">{passwordError}</span>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="input-group">
                    <label className="input-label">One-Time Password</label>
                    <div className="input-wrapper">
                      <FontAwesomeIcon
                        icon={faShieldAlt}
                        className="input-icon"
                      />
                      <input
                        type="text"
                        className={`form-input otp-input ${
                          otpError ? "error" : ""
                        }`}
                        placeholder="Enter 6-digit OTP"
                        value={otp}
                        onChange={handleOtpChange}
                        maxLength="6"
                        style={{ width: "100%", minWidth: "0" }}
                      />
                    </div>
                    {otpError && (
                      <span className="error-message">{otpError}</span>
                    )}
                  </div>

                  <div className="resend-container">
                    <button
                      type="button"
                      className="btn-resend"
                      onClick={handleSignIn}
                    >
                      Resend OTP
                    </button>
                  </div>
                </>
              )}

              <button
                type="button"
                className="btn-primaryy"
                onClick={showOtpField ? validateOtpOnServer : handleSignIn}
              >
                <span>{showOtpField ? "Verify & Login" : "Sign In"}</span>
                <FontAwesomeIcon icon={faRocket} />
              </button>

              {!showOtpField && (
                <div className="forgot-password">
                  <Link to="/admin/forget-password">Forgot your password?</Link>
                </div>
              )}
            </form>

            <div className="form-footer">
              <div className="footer-links">
                <a href="#">Privacy</a>
                <span>•</span>
                <a href="#">Terms</a>
                <span>•</span>
                <a href="#">Security</a>
              </div>
              <p className="recaptcha-text">Protected by reCAPTCHA</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin2;
